import React from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';
import parse from 'html-react-parser';
import { FORMAT_DATETIME_US } from '../../constants/common';
import { ActivityLogInterface, CommandActivity, ModuleTableEnum } from '../../types/activityLog';

const CUDAtOrBy = ['createdBy', 'createdAt', 'updatedAt'];

const convertModule = (module?: ModuleTableEnum) => {
  let moduleName;
  switch (module) {
    case ModuleTableEnum.TOUR_TRASH:
      moduleName = 'Tour Trash';
      break;
    case ModuleTableEnum.HOME_WIDGETS:
      moduleName = 'Home Widget';
      break;
    case ModuleTableEnum.ACCESS_CODE:
      moduleName = 'Access Code';
      break;
    case ModuleTableEnum.PERK:
      moduleName = 'Perk';
      break;
    case ModuleTableEnum.TTB:
      moduleName = 'TryThenBuy';
      break;
    case ModuleTableEnum.TTB_FRAUD:
      moduleName = 'TryThenBuy Fraud';
      break;
    case ModuleTableEnum.USER_BLACKLIST:
      moduleName = 'User BlackList';
      break;
    case ModuleTableEnum.USER:
      moduleName = 'User';
      break;
    case ModuleTableEnum.PRODUCT_ORDER:
      moduleName = 'Product';
      break;
    case ModuleTableEnum.PAID_FEATURE:
      moduleName = ModuleTableEnum.PAID_FEATURE;
      break;
    case ModuleTableEnum.SHOW_FEATURES:
      moduleName = ModuleTableEnum.SHOW_FEATURES;
      break;
    case ModuleTableEnum.LAUNCH_FEATURES:
      moduleName = ModuleTableEnum.LAUNCH_FEATURES;
      break;
    case ModuleTableEnum.LOYALTY_ACTION:
      moduleName = ModuleTableEnum.LOYALTY_ACTION;
      break;
    default:
      moduleName = '';
      break;
  }

  return moduleName;
};

export const convertToDescriptions = (record?: ActivityLogInterface): string => {
  const module = convertModule(record?.module);
  switch (record?.module) {
    case ModuleTableEnum.TOUR_TRASH:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.title}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} (${record?.nextColumnValue?.title}) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.title}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.HOME_WIDGETS:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.name}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} (${record?.nextColumnValue?.name}) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.name}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.ACCESS_CODE:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.code}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} (${record?.nextColumnValue?.code}) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.code}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.PERK:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.title}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} (${record?.nextColumnValue?.title}) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.title}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.TTB:
      switch (record?.command) {
        case CommandActivity.UPDATE:
          return `${module} (${record?.nextColumnValue?.orderId}) has been updated`;
        default:
          return `-`;
      }
    case ModuleTableEnum.TTB_FRAUD:
      switch (record?.command) {
        case CommandActivity.UPDATE:
          return `${module} (${record?.nextColumnValue?.orderId || record?.nextColumnValue?.email}) has been updated`;
        default:
          return `-`;
      }
    case ModuleTableEnum.USER_BLACKLIST:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.email}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} (${record?.prevColumnValue?.email}) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.email}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.USER:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.email}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} (${record?.prevColumnValue?.email}) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.email}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.PRODUCT_ORDER:
      switch (record?.command) {
        case CommandActivity.UPDATE:
          return `${module} ${record?.nextColumnValue?.country || ''} (${
            record?.prevColumnValue?.product_id
          }) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.product_id}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.PAID_FEATURE:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.feature || ''}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} ${record?.nextColumnValue?.countryCode || ''} (${
            record?.prevColumnValue?.feature
          }) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.feature}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.SHOW_FEATURES:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.feature || ''}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} ${record?.nextColumnValue?.countryCode || ''} (${
            record?.prevColumnValue?.feature
          }) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.feature}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.LAUNCH_FEATURES:
      switch (record?.command) {
        case CommandActivity.INSERT:
          return `${module} (${record?.nextColumnValue?.feature}) has been created`;
        case CommandActivity.UPDATE:
          return `${module} ${record?.nextColumnValue?.countryCode || ''} (${
            record?.prevColumnValue?.feature
          }) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.feature}) has been deleted`;
        default:
          return `-`;
      }
    case ModuleTableEnum.LOYALTY_ACTION:
      switch (record?.command) {
        case CommandActivity.UPDATE:
          return `${module} ${record?.nextColumnValue?.countries || ''} (${
            record?.prevColumnValue?.feature
          }) has been updated`;
        case CommandActivity.DELETE:
          return `${module} (${record?.prevColumnValue?.feature}) has been deleted`;
        default:
          return `-`;
      }
    default:
      return '';
  }
};

export const toConvertTitleActivity = (module?: ModuleTableEnum, nextColumnValue?: any) => {
  let titleConverted = '';

  switch (module) {
    case ModuleTableEnum.TOUR_TRASH:
      titleConverted = `Tour Trash Title: ${nextColumnValue?.title}`;
      break;
    case ModuleTableEnum.HOME_WIDGETS:
      titleConverted = `Home Widget Name: ${nextColumnValue?.name}`;
      break;
    case ModuleTableEnum.ACCESS_CODE:
      titleConverted = `Access Code: ${nextColumnValue?.code}`;
      break;
    default:
      titleConverted = '';
      break;
  }

  return titleConverted;
};

/**
 * Find difference between two objects
 * @param  {object} origObj - Source object to compare newObj against
 * @param  {object} newObj  - New object with potential changes
 * @return {object} differences
 */
function difference(origObj: any, newObj: any) {
  function changes(newO: any, origO: { [x: string]: any }) {
    let arrayIndexCounter = 0;
    return _.transform(newO, (result: { [x: string]: any }, value: any, key: string | number) => {
      if (!_.isEqual(value, origO[key])) {
        const resultKey = _.isArray(origO) ? (arrayIndexCounter += 1) : key;
        // eslint-disable-next-line no-param-reassign
        result[resultKey] = _.isObject(value) && _.isObject(origO[key]) ? changes(value, origO[key]) : value;
      }
    });
  }
  return changes(newObj, origObj);
}

const NodeDescription = (props: any): JSX.Element => {
  if (props?.description) {
    return <div className="activity-detail">{props.description}</div>;
  }
  return (
    <>
      <span>Change: </span>
      <div className="activity-detail">{parse(props?.from || 'null')}</div>
      <span>to </span>
      <div className="activity-detail">{parse(props?.to || 'null')}</div>
    </>
  );
};

export const toDifferentChangedTourTrash = (old: any, next: any, data: any, key?: string): any => {
  const diff = difference(old, next);
  for (const property in diff) {
    if (Object.prototype.hasOwnProperty.call(diff, property)) {
      const prevData = old?.[`${property}`];
      const nextData = next?.[`${property}`];
      switch (property) {
        case 'product':
          toDifferentChangedTourTrash(prevData, nextData, data, property);
          break;
        case 'images':
          data.push({
            title: `product - images`,
            description: <NodeDescription description="Product Image has been updated" />,
          });
          break;
        case 'startDate':
        case 'endDate':
          data.push({
            title: property,
            description: (
              <NodeDescription
                from={moment(prevData).format(FORMAT_DATETIME_US)}
                to={moment(nextData).format(FORMAT_DATETIME_US)}
              />
            ),
          });
          break;
        default:
          if (!CUDAtOrBy.includes(property)) {
            data.push({
              title: `${key ? `${key} -` : ''} ${property}`.trim(),
              description: (
                <NodeDescription
                  from={!_.isNil(prevData) ? prevData.toString() : prevData}
                  to={!_.isNil(nextData) ? nextData.toString() : nextData}
                />
              ),
            });
          }
          break;
      }
    }
  }

  return data;
};

export const toDifferentChangedOther = (old: any, next: any, data: any, key?: string): any => {
  const diff = difference(old, next);
  for (const property in diff) {
    if (Object.prototype.hasOwnProperty.call(diff, property)) {
      const prevData = old?.[`${property}`];
      const nextData = next?.[`${property}`];
      if (!CUDAtOrBy.includes(property)) {
        data.push({
          title: `${key ? `${key} -` : ''} ${property}`.trim(),
          description: (
            <NodeDescription
              from={!_.isNil(prevData) ? prevData.toString() : prevData}
              to={!_.isNil(nextData) ? nextData.toString() : nextData}
            />
          ),
        });
      }
    }
  }

  return data;
};
